import { disableBodyScroll as _disableBodyScroll } from 'body-scroll-lock';
export { clearAllBodyScrollLocks, enableBodyScroll } from 'body-scroll-lock';

export function scrollTo(selector, { offset = 0, behavior = 'smooth' } = {}) {
  const element = document.querySelector(selector);

  if (!element) return;

  const height = element.getBoundingClientRect().top;

  window.scrollBy({
    top: height + offset,
    behavior,
  });
}

export function disableBodyScroll(target) {
  _disableBodyScroll(target, {
    allowTouchMove(el) {
      while (el instanceof Element && el instanceof HTMLElement && el !== document.body) {
        if (el.className && el.className.includes('js-allow-touch-move')) return true;

        el = el.parentNode;
      }
    },
  });
}
